import { useTranslation } from 'react-i18next'

import { useAuth } from '@features/auth/provider'
import LoginOrRegister from '@features/auth/ui/form/login-or-register'
import { useModalStore } from '@features/modal'

import useProfileCustomerModal from './useProfileCustomerModal'


export default function useAuthFlow (onCallback?: () => void) {
  const { t: ta } = useTranslation('auth')
  const { user, requireRegistration, loading: loadingUser } = useAuth()
  const { openModal } = useModalStore()
  const { openProfileCustomerModal } = useProfileCustomerModal()

  return () => {
    if (loadingUser) return

    if (!user) {
      openModal('loginOrRegister', <LoginOrRegister />, {
        title: ta('login.title'),
      })
      return
    }

    if (requireRegistration) {
      openProfileCustomerModal()
      return
    }

    if (onCallback) {
      onCallback()
    }
  }
}
